module.exports = __webpack_public_path__ + "img/bar_top_right_corner.c6cd53fe.png";